<!-- eslint-disable vuejs-accessibility/tabindex-no-positive -->
<template>
  <nav
    class="
      sus:text-peach-dark-500
      fixed -top-full left-[10%] z-[1000] rounded border-2 border-surface-300 bg-surface-300 px-8 pb-5 pt-6
      shadow-lg transition-all
      teacher:bg-white
      student:bg-white
      2nd:text-violet-dark-500
      md:focus-within:-top-1
    "
    aria-label="Accessibility navigation"
  >
    <ul class="space-y-2">
      <li>
        <button
          tabindex="1"
          class="focus-default px-2 hover:underline teacher:text-teacher-text-lg"
          type="button"
          @click="jumptoid('jump-navigation')"
        >
          <span>{{ $t('navigate.toNav') }}</span>
        </button>
      </li>
      <li>
        <button
          tabindex="1"
          class="focus-default px-2 hover:underline teacher:text-teacher-text-lg"
          type="button"
          @click="jumptoid('jump-contend-start')"
        >
          <span>{{ $t('navigate.toPage') }}</span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
useTabHelper()

function jumptoid(id: string) {
  const el = document.getElementById(id)

  if (el?.getElementsByTagName('a')[0]) {
    el?.getElementsByTagName('a')[0]?.focus()
  } else {
    el?.focus()
  }

  el?.scrollIntoView({ behavior: 'smooth' })
}
</script>
